import * as React from "react"

import { cn } from "~/lib/utils"

type InputDensity = "compact" | "comfortable"

const DENSITY: Record<InputDensity, string> = {
  compact: "h-8 rounded-md px-2.5 text-[13px]",
  comfortable: "h-12 rounded-lg px-3.5 text-[16px]",
}

function Input({
  className,
  type,
  density = "compact",
  ...props
}: React.ComponentProps<"input"> & { density?: InputDensity }) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "w-full min-w-0 border border-hairline bg-surface leading-none transition-colors outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-[13px] file:font-medium file:text-foreground placeholder:text-text-faint disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        DENSITY[density],
        "focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-0",
        "aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/30",
        className
      )}
      {...props}
    />
  )
}

export { Input }
